import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import HttpService from '../services/HttpServices';

const apiService = HttpService;

const initialState = {
    bannerId: '',
    bannerHeader: "",
    bannerText: "",
    bannerImagePath: "",
    startTime: "",
    endTime: "",
    companyTypeId: [],
    isVisibleToAll: '',
    loading: false,
    error: false
}

export const fetchBannerById = createAsyncThunk(
    'getBanner',
    async (id, thunkAPI) => {
        try {
            const response = await apiService.get(`banners/${id}`)
            return response.data
        }
        catch (err) {
            return thunkAPI.rejectWithValue(err.response.data || err.message);
        }
    }
)

export const createBanner = createAsyncThunk(
    'postBanner',
    async (banner, thunkAPI) => {
        try {
            const response = await apiService.post(`banners`, {
                banner
            })
            return response.data
        }
        catch (err) {
            return thunkAPI.rejectWithValue(err.response.data || err.message);
        }
    }
)

export const getCompanyTypes = async () => {
    try {
        const response = await apiService.get(`public/lookups/company-types`)
        return response.data
    } catch (err) {
        return err
    }
}

export const deleteBanner = async (id) => {
    const response = await apiService.delete(`banners/${id}`);
    return response.data;
}

export const uploadBanner = async (data) => {
    const response = await apiService.post('upload/image', data, { headers: { 'Content-Type': 'multipart/form-data' } })
    return response.data
}

export const addBanner = async (data) => {
    const response = await apiService.post(`banners`, data)
    return response.data
}

export const editBanner = async (data) => {
    const response = await apiService.put(`banners/${data.bannerId}`, data)
    return response.data
}

export const bannerSlice = createSlice({
    name: "banner",
    initialState: initialState,
    reducers: {
        reset: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBannerById.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchBannerById.fulfilled, (state, action) => {
                if (action.payload.data.length > 0) {
                    state.bannerHeader = action.payload.data[0].bannerHeader; // This is your response.data.data
                    state.bannerId = action.payload.data[0].bannerId
                    state.bannerImagePath = action.payload.data[0].bannerImagePath
                    state.bannerText = action.payload.data[0].bannerText
                    if (action.payload.data[0].companyTypeId != null) {
                        let companyIds = action.payload.data[0].companyTypeId.split(",")
                        companyIds.map((ids) => state.companyTypeId.push(parseInt(ids)))
                    }
                    state.endTime = action.payload.data[0].endTime
                    state.startTime = action.payload.data[0].startTime
                    state.isVisibleToAll = action.payload.data[0].isVisibleToAll
                }
                state.loading = false;
            })
            .addCase(fetchBannerById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Ensure this is in a usable format
            })
            .addCase(createBanner.pending, (state) => {
                state.loading = true;
            })
            .addCase(createBanner.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(createBanner.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload; // Ensure this is in a usable format
            })
    }
})

export const { reset } = bannerSlice.actions

export default bannerSlice.reducer;